/**
 * Centralized in-app route paths so they don't drift between callers.
 * Use these with `react-router`'s `navigate(...)` or `<Link to=...>`.
 *
 * The `AccountPage` recognizes `tab=profile | billing | earnings | settings | developer`;
 * any other `tab` value silently falls back to `profile`, which is why
 * arbitrary literals like `?tab=credits` must not be reintroduced.
 */
export const ACCOUNT_PATH = '/account';
export const ACCOUNT_BILLING_PATH = '/account?tab=billing';
export const ACCOUNT_BILLING_PLANS_PATH = '/account?tab=billing&sub=plans';
export const ACCOUNT_BILLING_MEMBERSHIP_PATH = `${ACCOUNT_BILLING_PLANS_PATH}&focus=membership`;
/** Compatibility name for existing credit-shortage entry points. */
export const ACCOUNT_BILLING_CREDITS_PATH = `${ACCOUNT_BILLING_PLANS_PATH}&focus=credits`;
export const ACCOUNT_EARNINGS_PATH = '/account?tab=earnings';
export const ACCOUNT_SETTINGS_PATH = '/account?tab=settings';
export const ACCOUNT_DEVELOPER_PATH = '/account?tab=developer';
export const API_DOCS_PATH = '/api-docs';
